
type storeKey = keyof storeDetailParameter;
import { storeDetailParameter, addStoreParameter } from "@/assets/types/common";
import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
} from "vue";
// import AMap from "AMap";
import { useRoute, useRouter } from "vue-router";
import {
    getStoreInfo,
    getQiNiuYunToken,
    getEditStore,
    postAddStore,
} from "@/api/http";
import { ElMessage } from "element-plus";
import { storeUser } from "@/store/User";

import { column } from "@/assets/types/common";
const qiniu: any = require("qiniu-js");

export default defineComponent({
    name: "FrameworkEdit",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["门店设置"]);
        const route = useRoute();
        const isAdd = route.name == "frameworkAdd";
        const router = useRouter();
        let user = storeUser.getUser();
        let form = ref({
                store_name: "",
                posid: "",
                service_phone: null,
                address: "",
                contacts: "",
                phone: null,
                admin_name: "",
                lnitial_password: "",
                longitude: 0,
                latitude: 0,
                desc: "",
                payment_account: "",
                payee: "",
                end_time: null,
                pump: null,
            } as storeDetailParameter),
            formRef = ref(null),
            formLoading = ref(false),
            exhibitionUrl = ref({ url: "", key: "" }),
            token = "",
            bucketURL = "",
            pump = ref(""),
            bannerImg = ref([] as Array<string>),
            bannerKey: Array<string> = [],
            uploadType = true,
            bannerLoading = ref(false),
            exhibitionLoading = ref(false),
            rules = {
                store_name: [
                    {
                        required: true,
                        message: "请输入门店名称",
                        trigger: "change",
                    },
                ],
                posid: [
                    {
                        required: true,
                        message: "请输入建行柜台号",
                        trigger: "change",
                    },
                ],
                exhibition: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: string,
                            callback: Function
                        ) => {
                            if (exhibitionUrl.value.key) {
                                callback();
                            } else {
                                callback(new Error("请上传门店展示图"));
                            }
                        },
                        trigger: "change",
                    },
                ],
                banner: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: string,
                            callback: Function
                        ) => {
                            if (bannerImg.value.length > 0) {
                                callback();
                            } else {
                                callback(new Error("最少上传一张门店轮播图"));
                            }
                        },
                        trigger: "change",
                    },
                ],
                address: [
                    { required: true, message: "必填项", trigger: "blur" },
                ],
                contacts: [
                    {
                        required: true,
                        message: "请输入联系人",
                        trigger: "change",
                    },
                ],
                phone: [
                    {
                        required: true,
                        message: "请输入联系电话",
                        trigger: "change",
                    },
                ],
                service_phone: [
                    {
                        required: true,
                        message: "请输入客服电话",
                        trigger: "change",
                    },
                ],
                admin_name: [
                    {
                        required: true,
                        message: "请输入管理员账号",
                        trigger: "change",
                    },
                ],
                lnitial_password: [
                    {
                        required: true,
                        message: "请输入密码",
                        trigger: "change",
                    },
                ],
                payment_account: [
                    {
                        required: true,
                        message: "请输入收款账户",
                        trigger: "change",
                    },
                ],
                end_time: [
                    {
                        required: true,
                        message: "请选择有效日期",
                        trigger: "change",
                    },
                ],
                pump: [
                    {
                        required: true,
                        message: "请输入抽成比例",
                        trigger: "change",
                    },
                ],
                payee: [
                    {
                        required: true,
                        message: "请输入收款人",
                        trigger: "change",
                    },
                ],
            };

        let beforeAvatarUpload = (file: File) => {
                const isJPG = file.type === "image/jpeg";
                const isPNG = file.type === "image/png";
                if (!isJPG && !isPNG) {
                    ElMessage.error("上传图片只能是 JPG 或 PNG 格式!");
                }
                return isJPG && isPNG;
            },
            inputNum = (value:any) => {
                if (value == undefined) return;
                return value.toString()
                    .replace(/[^\d.]/g, "")
                    .replace(/\.{2,}/g, ".")
                    .replace(".", "$#$")
                    .replace(/\./g, "")
                    .replace("$#$", ".")
                    .replace(/^\./g, "");
            },
            uploadImg = (file: any) => {
                let config = {
                    useCdnDomain: true,
                    // region: qiniu.region.z2,
                };
                let putExtra = {
                    fname: "",
                    params: {},
                    mimeType: null,
                };
                let observable: any = {};
                observable = qiniu.upload(file, null, token, putExtra, config);

                const observer = {
                    next(res: any) {},
                    error(err: any) {},
                    complete(res: any) {
                        if (uploadType) {
                            bannerImg.value.push(bucketURL + res.key);
                            bannerKey.push(res.key);
                            bannerLoading.value = false;
                        } else {
                            exhibitionUrl.value.url = bucketURL + res.key;
                            exhibitionUrl.value.key = res.key;
                        }
                    },
                };
                observable.subscribe(observer);
            },
            handleChange = (file: any, type: boolean) => {
                uploadType = type;
                if (type) {
                    bannerLoading.value = true;
                } else {
                    exhibitionLoading.value = true;
                    exhibitionUrl.value = {
                        url: "",
                        key: "",
                    };
                }
                uploadImg(file.raw);
            },
            imgLoad = () => {
                exhibitionLoading.value = false;
            },
            editInfo = () => {
                return new Promise(function (resove: any, reject: any) {
                    if (!isAdd) {
                        formLoading.value = true;
                        getStoreInfo({ id: route.query.id }).then(
                            (res: any) => {
                                formLoading.value = false;
                                if (res.status == 200) {
                                    let list = res.content.list;
                                    form.value = list;
                                    //pump.value = `每一笔订单平台将抽成${list.pump}%`;

                                    exhibitionUrl.value = list.img;
                                    bannerImg.value = [];
                                    console.log(list.banner_img);
                                    type banner_img = {
                                        url:string,key:string
                                    };
                                     bannerImg.value = list.banner_img.map((item:banner_img) => item.url)
                                     bannerKey = list.banner_img.map((item:banner_img) => item.key)

                                    // form.value = {
                                    //     service_phone: list.service_phone,
                                    //     address: list.address,
                                    //     store_name: list.store_name,
                                    //     contacts: list.contacts,
                                    //     phone: list.phone,
                                    //     admin_name: list.admin_name,
                                    //     lnitial_password: list.lnitial_password,
                                    //     longitude: list.longitude,
                                    //     latitude: list.latitude,
                                    //     desc: list.desc,
                                    //     payment_account: "",
                                    //     payee: "",
                                    // };
                                }
                                resove();
                            }
                        );
                    } else {
                        resove();
                    }
                });
            },
            onSubmit = () => {
                (formRef.value as any).validate((valid: boolean) => {
                    if (valid) {
                        // 总门店与门店共同的参数
                        let parameter = {
                            store_name: "",
                            posid: "",
                            service_phone: null,
                            address: "",
                            contacts: "",
                            phone: null,
                            admin_name: "",
                            lnitial_password: "",
                            longitude: 0,
                            latitude: 0,
                            desc: "",
                        };
                        if (isAdd) {
                            let data: any = {
                                ...parameter,
                                end_time: null,
                                pump: null,
                            };

                            Object.keys(data).forEach(
                                <key extends keyof storeDetailParameter>(
                                    key: string
                                ) => {
                                    data[key as key] = form.value[key as key];
                                }
                            );
                            data.end_time = Date.parse(data.end_time) / 1000;
                            postAddStore({
                                ...data,
                                banner_img: bannerKey,
                                img: exhibitionUrl.value.key,
                            }).then((res) => {
                                if (res.status == 202) {
                                    router.back();
                                }
                            });
                        } else {
                            // 门店参数
                            let formData: storeDetailParameter = {
                                    ...parameter,
                                    payment_account: "",
                                    payee: "",
                                    end_time: null,
                                    pump: null,
                                },
                                data = {
                                    id: route.query.id,
                                    banner_img: bannerKey,
                                    img: exhibitionUrl.value.key,
                                };

                            Object.keys(formData).forEach(
                                <key extends keyof storeDetailParameter>(
                                    key: string
                                ) => {
                                    formData[key as key] =
                                        form.value[key as key];
                                }
                            );
                            (formData.end_time =
                                Date.parse(form.value.end_time as any) / 1000),
                                getEditStore({ ...data, ...formData }).then(
                                    (res: any) => {
                                        if (res.status == 202) {
                                            router.back();
                                        }
                                    }
                                );
                        }
                    }
                });
                // console.log(form.value);
            },
            _delimg = (index: number) => {
                bannerImg.value.splice(index, 1);
                bannerKey.splice(index, 1)
            };

        onMounted(() => {
            editInfo().then(() => {
                var position = [form.value.longitude, form.value.latitude];
                // var map = new AMap.Map("mapChart", {
                //     resizeEnable: true,
                //     center: position,
                //     zoom: 14,
                // });
                // // 绑定搜索框
                // AMap.plugin(
                //     ["AMap.Autocomplete", "AMap.PlaceSearch"],
                //     function () {
                //         // 实例化Autocomplete
                //         var autoOptions = {
                //             input: "addressInput",
                //         };
                //         var autoComplete = new AMap.Autocomplete(autoOptions);
                //         var placeSearch = new AMap.PlaceSearch({
                //             city: "东莞",
                //             map: map,
                //         });
                //         // 搜索地址回调
                //         AMap.event.addListener(
                //             autoComplete,
                //             "select",
                //             (res: any) => {
                //                 form.value.address = res.poi.name;
                //                 form.value.latitude = res.poi.location.lat;
                //                 form.value.longitude = res.poi.location.lng;
                //                 placeSearch.search(res.poi.name);
                //             }
                //         );
                //     }
                // );
                //
                // var marker = new AMap.Marker({
                //     position,
                //     offset: new AMap.Pixel(-13, -30),
                // });
                // marker.setMap(map);
                //
                // map.on("click", function (e: any) {
                //     form.value.longitude = e.lnglat.getLng();
                //     form.value.latitude = e.lnglat.getLat();
                //
                //     marker.setPosition([
                //         form.value.longitude,
                //         form.value.latitude,
                //     ]);
                // });
                //
                // map.setFitView();
            });
            getQiNiuYunToken().then((res: any) => {
                token = res.content.token;
                bucketURL = res.content.domain;
            });
        });

        return {
            user,
            form,
            formRef,
            rules,
            formLoading,
            beforeAvatarUpload,
            exhibitionUrl,
            bannerImg,
            pump,
            bannerLoading,
            exhibitionLoading,
            imgLoad,
            handleChange,
            onSubmit,
            _delimg,
            inputNum,
        };
    },
});
